export default {
  fiche: {
    list: {
      title: 'List of advice sheets',
      noDataText: 'Aucune fiche ne correspond aux critères de recherche',
      downloadHover: 'Télécharger',
      eyeHover: 'Visualiser',
      headers: {
        libelleDocument: 'Wording',
        nomDocument: 'Name of the document',
        dateCreation: 'Creation date',
        typeDocument: 'Type',
      },
    },
  },
}
